import { useQuery } from '@tanstack/react-query';
import { dataService, Logger } from '../services/data';

export function useLoggers(siteId?: string) {
  return useQuery<Logger[], Error>({
    queryKey: ['loggers', siteId],
    queryFn: () => dataService.getLoggers(siteId),
  });
}

export function useLogger(id: string | undefined) {
  return useQuery<Logger, Error>({
    queryKey: ['loggers', id],
    queryFn: () => dataService.getLogger(id!),
    enabled: !!id,
  });
}
